import { makeStyles } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import queryString from 'query-string';
import React from 'react';
import Typography from '~components/typography';
import { BasicHome } from '~svg-components';
import { FORMAT_DAY_DATE_MONTH_YEAR } from '~utils/date-format';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'stretch',
      minWidth: '360px',
      padding: '12px 12px 10px 16px',
      minHeight: '72px',
      marginBottom: '12px',
      backgroundColor: theme.colors.white,
      borderRadius: theme.borderRadius.small,
      border: `1px solid ${theme.colors.greyE8}`,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.colors.greyFa,
      },
    },

    mainNominationInfo: {
      display: 'block',
      marginRight: '8px',
      flex: 1,
    },

    nominationNameAndPropertyNameRoot: {
      display: 'inline',
      marginBottom: 6,
    },

    propertyNameWithIconRoot: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },

    propertyNameWithIcon: {
      ...theme.flex.center,
      padding: '0 8px',
      backgroundColor: theme.colors.greyE8,
      borderRadius: '20px',
      marginLeft: 8,
    },

    propertyName: {
      marginLeft: 8,
      display: 'inline',
    },

    otherNominationInfo: {
      ...theme.flex.crossCenter,
    },

    divider: {
      margin: '0 8px',
    },

    nominationPlanName: {
      display: 'inline',
      verticalAlign: 'middle',
    },
  }),
  { name: 'NominationPlanCardRecentlyViewed' }
);

function NominationPlanCardRecentlyViewed({ nominationPlan }) {
  const classes = useStyles();

  const {
    name,
    propertyName,
    endDate,
    startDate,
    academicYearName,
    propertyId,
    academicYearId,
    nominationPlanId,
  } = nominationPlan;

  const renderNominationNameAndPropertyName = () => (
    <div className={classes.nominationNameAndPropertyNameRoot}>
      <Typography variant="body1" themeColor="dark" className={classes.nominationPlanName}>
        {name || '-'}
      </Typography>
      <div className={classes.propertyNameWithIconRoot}>
        <div className={classes.propertyNameWithIcon}>
          <BasicHome color="grey66" fontSize={12} style={{ verticalAlign: 'middle' }} />
          <Typography variant="body2" themeColor="grey66" className={classes.propertyName}>
            {propertyName || '-'}
          </Typography>
        </div>
      </div>
    </div>
  );

  const renderCheckInCheckOut = () => (
    <Typography variant="body2" themeColor="grey66" className={classes.tenancy}>
      {`${format(parseISO(startDate), FORMAT_DAY_DATE_MONTH_YEAR)} - ${format(
        parseISO(endDate),
        FORMAT_DAY_DATE_MONTH_YEAR
      )}`}
    </Typography>
  );

  const renderDivider = () => (
    <Typography variant="body1" themeColor="greyE8" className={classes.divider}>
      |
    </Typography>
  );

  const renderAcademicYearName = () => (
    <Typography variant="body2" themeColor="grey66">
      {academicYearName || '-'}
    </Typography>
  );

  const renderAcademicYearNameAndTenancy = () => (
    <div className={classes.otherNominationInfo}>
      {renderAcademicYearName()}
      {renderDivider()}
      {startDate && endDate && renderCheckInCheckOut()}
    </div>
  );

  const renderMainNominationInfo = () => (
    <div className={classes.mainNominationInfo}>
      {renderNominationNameAndPropertyName()}
      {renderAcademicYearNameAndTenancy()}
    </div>
  );

  const openNominationPlanPage = () => {
    const nominationPlanUrl = queryString.stringifyUrl({
      url: '/nominations',
      query: {
        academicYearId,
        nominationPlanId,
        propertyId,
      },
    });
    window.open(nominationPlanUrl);
  };

  return (
    <div
      className={classes.root}
      onClick={() => {
        openNominationPlanPage();
      }}
    >
      {renderMainNominationInfo()}
    </div>
  );
}

export default NominationPlanCardRecentlyViewed;
